import { render } from "./FileEditForm.vue?vue&type=template&id=2d595c96"
import script from "./FileEditForm.vue?vue&type=script&lang=js"
export * from "./FileEditForm.vue?vue&type=script&lang=js"
script.render = render

export default script